import Vue from "vue";
import BuyCourse from "@/models/BuyCourse";
import BuyCourseDate from "@/models/BuyCourseDate";
import PublicBuyCourseDate from "@/models/PublicBuyCourseDate";

export default class BuyCourseApi {

    constructor(api) {
        this.api = api;
    }

    getAgb(callback, error) {
        this.api.getRaw((axios) => {
            axios.get("buycourse/agb").then((response) => {
                callback(response.data);
            }).catch((err) => {
                Vue.$log.error("Error", err);
                if (error) error(err)
            });
        }, true);
    }

    updateAgb(agb, callback, error) {
        this.api.getRaw((axios) => {
            axios.post("buycourse/agb", agb).then((response) => {
                callback(response.data);
            }).catch((err) => {
                Vue.$log.error("Error", err);
                if (error) error(err)
            });
        });
    }

    get(id, callback, error) {
        this.api.getRaw((axios) => {
            axios.get("buycourse/" + id).then((response) => {
                callback(new BuyCourse(response.data));
            }).catch((err) => {
                Vue.$log.error("Error", err);
                if (error) error(err)
            });
        });
    }

    getAll(callback, error) {
        this.api.getRaw((axios) => {
            axios.get("buycourse").then((response) => {
                console.log(response)
                callback(response.data.map((date) => new BuyCourse(date)));
            }).catch((err) => {
                Vue.$log.error("Error", err);
                if (error) error(err)
            });
        });
    }

  createTime(id, start, end, callback, error) {
    this.api.getRaw((axios) => {
      axios.post("buycourse/" + id + "/createDate", {start: start, end: end}).then((response) => {
        callback();
      }).catch((err) => {
        if (error) error(err)
      });
    });
  }

  updateTime(id, dateId, start, end, callback, error) {
    this.api.getRaw((axios) => {
      axios.post("buycourse/" + id + "/createDate/"+dateId, {start: start, end: end}).then((response) => {
        callback();
      }).catch((err) => {
        if (error) error(err)
      });
    });
  }

    uploadAttachment(file, callback, error) {
        let formData = new FormData();
        formData.append("file", file);
        this.api.getRaw((axios) => {
            axios.post("buycourse/uploadAttachment", formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            }, () => {
            }).then((result) => {
                callback(result.data);
            }).catch((err) => {
                Vue.$log.error("Error", err);
                if (error) error(err)
            });
        }, true);
    }

    downloadAttachment(name) {
        this.api.getRaw((axios) => {
            axios.get("buycourse/downloadAttachment/" + name, {responseType: 'blob'})
                .then(response => {
                    const blob = new Blob([response.data], {type: '*/+'})
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob)
                    link.download = name;
                    link.click()
                    URL.revokeObjectURL(link.href)
                }).catch((err) => {
                console.error(err);
            })
        })
    }

    getPublic(callback, error) {
        this.api.getRaw((axios) => {
            axios.get("buycourse/upcoming").then((response) => {
                callback(response.data.map((date) => new PublicBuyCourseDate(date)));
            }).catch((err) => {
                if (error) error(err)
            });
        }, true);
    }

    getTimes(id, includePast, callback, error) {
        if (typeof includePast === "function") {
            error = callback;
            callback = includePast;
            includePast = false;
        }

        this.api.getRaw((axios) => {
            axios.get("buycourse/" + id + "/details", {
                params: {
                    includePast: includePast === true
                }
            }).then((response) => {
                callback(response.data.map((date) => new BuyCourseDate(date)));
            }).catch((err) => {
                if (error) error(err)
            });
        });
    }

  deleteTime(id, timeId, callback, error) {
    this.api.getRaw((axios) => {
      axios.delete("buycourse/" + id + "/" + timeId).then((response) => {
        callback();
      }).catch((err) => {
        if (error) error(err)
      });
    });
  }

  denyApplicant(id, timeId, participantId, callback, error) {
    this.api.getRaw((axios) => {
      axios.delete("buycourse/" + id + "/" + timeId + "/" + participantId).then((response) => {
        callback();
      }).catch((err) => {
        if (error) error(err)
      });
    });
  }

  acceptApplicant(id, timeId, participantId, callback, error) {
    this.api.getRaw((axios) => {
      axios.post("buycourse/" + id + "/" + timeId + "/" + participantId).then((response) => {
        callback();
      }).catch((err) => {
        if (error) error(err)
      });
    });
  }

    create(data, callback, error) {
        this.api.getRaw((axios) => {
            axios.post("buycourse", data).then((response) => {
                callback(new BuyCourse(response.data));
            }).catch((err) => {
                if (error) error(err)
            });
        });
    }

    delete(id, callback, error) {
        this.api.getRaw((axios) => {
            axios.delete("buycourse/" + id).then(() => {
                callback();
            }).catch((err) => {
                if (error) error(err)
            });
        });
    }

    apply(courseId, dateId, data, callback, error) {
        this.api.getRaw((axios) => {
            axios.post("buycourse/" + courseId + "/" + dateId + "/apply", data).then((response) => {
                callback()
            }).catch((err) => error(err));
        }, true);
    }

}
